import Vue from 'vue';
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet';
import LControlFullscreen from 'vue2-leaflet-fullscreen';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-control-fullscreen', LControlFullscreen);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-icon', LIcon);
